import { render, staticRenderFns } from "./NavigationProductsReservoirs.vue?vue&type=template&id=18b2847d&scoped=true"
import script from "./NavigationProductsReservoirs.vue?vue&type=script&lang=js"
export * from "./NavigationProductsReservoirs.vue?vue&type=script&lang=js"
import style0 from "./NavigationProductsReservoirs.vue?vue&type=style&index=0&id=18b2847d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2847d",
  null
  
)

export default component.exports